export * from './NatureFxSparkleA2Icon';
export * from './NatureFxSparkleA2Icon16Light';
export * from './NatureFxSparkleA2Icon16Regular';
export * from './NatureFxSparkleA2Icon16Solid';
export * from './NatureFxSparkleA2Icon20Light';
export * from './NatureFxSparkleA2Icon20Regular';
export * from './NatureFxSparkleA2Icon20Solid';
export * from './NatureFxSparkleA2Icon24Regular';
export * from './NatureFxSparkleA2Icon24Solid';
export * from './NatureFxSparkleA2Icon32Regular';
export * from './NatureFxSparkleA2Icon64Regular';
